module.exports = __webpack_public_path__ + "img/NewRedStar.ec0c5abc.svg";